module.exports = __webpack_public_path__ + "img/facebook-logo.5f16d6ef.svg";